/**
 * The function returns URL-encoded string or null if the cookie doesn't exist
 * https://stackoverflow.com/questions/10730362/get-cookie-by-name
 */
export const getCookieByName = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match?.[2] || null;
};
